import { Center, Loader } from '@mantine/core';

export function FullscreenLoader() {
  return (
    <Center h="100vh">
      <Loader color="var(--mantine-color-brand-6)" />
    </Center>
  );
}
